import "./App.css";
import Header from "./components/Header";
import Footer from "./components/Footer";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Terms from "./pages/Terms-and-Conditions";
import Shipping from "./pages/Shipping-Policy";
import Refund from "./pages/Refund-Policy";
import Privacy from "./pages/Privacy-Policy";
import Cancellation from "./pages/Cancellation-Policy";
import Authenticity from "./pages/Authenticity";
import Contact from "./pages/Contact";
import ProductDetails from "./pages/ProductDetails";
import MadhumehSugarPowder from "./pages/MadhumehSugarPowder";
import PaachanCarePowder from "./pages/PaachanCarePowder";
import LiverCareTablet from "./pages/LiverCareTablet";
import DiacarePowder from "./pages/DiacarePowder";
import DiacorexTablet from "./pages/DiacorexTablet";
import ShilajitPlus from "./pages/ShilajitPlus";
import Stamina from "./pages/Stamina";

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/Terms-and-Conditions" element={<Terms />} />
        <Route path="/Shipping-Policy" element={<Shipping />} />
        <Route path="/Refund-Policy" element={<Refund />} />
        <Route path="/Privacy-Policy" element={<Privacy />} />
        <Route path="/Cancellation-Policy" element={<Cancellation />} />
        <Route path="/Authenticity" element={<Authenticity />} />
        <Route path="/products/:slug" element={<ProductDetails />} />

        <Route path="/products/madhumeh-sugar-powder" element={<MadhumehSugarPowder />} />
        <Route path="/products/paachan-care-powder" element={<PaachanCarePowder />} />
        <Route path="/products/liver-care-tablet" element={<LiverCareTablet />} />
        <Route path="/products/diacare-powder" element={<DiacarePowder />} />
        <Route path="/products/diacorex-tablet" element={<DiacorexTablet />} />
        <Route path="/products/shilajit-plus" element={<ShilajitPlus />} />
        <Route path="/products/stamina" element={<Stamina />} />
      </Routes>
      <Footer />
    </Router>
  );
}
export default App;